<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011465791.png"
                alt=""
                title="" /></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <router-link :to="{name:'首頁'}" class="breadCrumb_no"><span>首頁</span></router-link>
        <router-link :to="{name:'工作環境'}"><span>人才招募</span></router-link>
        <router-link :to="{name:'工作環境'}"><span>幸福白金</span></router-link>
        <router-link :to="{name:'工作環境'}"><span>工作環境</span></router-link>
      </div>
      <h2 class="titleA">
        工作環境
      </h2>
      <div id="page_left">
        <div id="menu_out">
          <div id="menu_c">
            <ul class="m_top"></ul>
            <li>
              <router-link :to="{name:'工作環境'}" class="menu_on0">幸福白金</router-link>
              <span style="cursor:hand" class="arrow_class_close"
                onclick="allshow_show_menu2(this,'1950','http://www.ptotinc.com/','0','','1951')">
                <img src="@/assets/folder_close.png" id="img_son_menu_1950" class="class_sonimg_0">
              </span>
            </li>
            <div id="son_menu_1950" class="class_sondiv_0" style="">
              <ol>
                <router-link :to="{name:'工作環境'}" class="menu_on2">工作環境</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'餐廳環境'}" class="menu_on0">餐廳環境</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'籃球社'}" class="menu_on0">籃球社</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'瑜珈社'}" class="menu_on0">瑜珈社</router-link>
              </ol>

            </div>
            <li>
              <router-link :to="{name:'加入白金'}" class="menu_on0">加入白金</router-link>
            </li>
          </div>
        </div>
      </div>

      <div id="page_right_no">
        <!--###右側欄區塊###-->
      </div>

      <div id="page_main_2">
        <!--###內頁中間內容區塊###-->
        <div class="cC">

          <form method="POST" action="portal_c2_cnt.php?owner_num=c2_34776&button_num=c2&folder_id=1951&search_type=1">

            <div class="searchbar">
              <ul>
                <li>

                  尋找：

                  <select tabindex="62" name="search_field">
                    <option value="all_field">全部</option>
                    <option value="text_field_0">標題</option>
                  </select>
                  <input tabindex="63" name="search_word" type="text" class="input" value="" />
                  <input tabindex="64" name="search_b1" type="submit" class="btn" value="查詢" />
                  <!--<input name="Submit3" type="button" class="btn2" value="進階查詢" onclick="location.href='http://www.ptotinc.com/member/ptotinc/portal_c2_cnt.php?owner_num=c2_34776&button_num=c2&folder_id=1951&search_type=2';"/>-->
                </li>
              </ul>
            </div>
          </form>

          <div class="cate_info"> <img alt=""
              src="~@/assets/DSCF1972.jpg"
              style="width: 2000px; height: 1125px;" /><br />

            &nbsp;

            <table border="0" cellpadding="0" cellspacing="0" style="width: 100%;">

              <tbody>

                <tr>

                  <td style="width: 50%;"><img alt=""
                      src="~@/assets/DSC_0012.jpg"
                      style="width: 100%;" /></td>

                  <td style="width: 50%;"><img alt=""
                      src="~@/assets/DSC_0014.jpg"
                      style="width: 100%;" /></td>

                </tr>

                <tr>

                  <td style="width: 50%;"><img alt=""
                      src="~@/assets/DSC_0016.jpg"
                      style="width: 100%;" /></td>

                  <td style="width: 50%;"><img alt=""
                      src="~@/assets/DSC_0041.jpg"
                      style="width: 100%;" /></td>

                </tr>

                <tr>

                  <td style="width: 50%;"><img alt=""
                      src="~@/assets/DSC_0105.jpg"
                      style="width: 100%;" /></td>

                  <td style="width: 50%;"><img alt=""
                      src="~@/assets/DSC_0091.jpg"
                      style="width: 100%;" /></td>

                </tr>

              </tbody>

            </table>

          </div>

          <ul id="c_list">
          </ul>

          <br><br>
          <p style="text-align:center;">
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'workarea',
  data () {
    return {
      isAboutPage: true
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    this.$emit('setCurrentMenu', 'about'); // about/ product/ recruit/ contactus
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      // initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/joinus/Workarea.vue